import { testEnvironment } from '../consts'

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {}

export const isEmptyObject = (obj: Record<string, unknown>): boolean => {
  if (!obj) return true
  return Object.keys(obj).length === 0 && obj.constructor === Object
}

export const maskValue = (value: string | number): string => {
  const strValue = String(value);

  return strValue?.length <= 3 ? strValue : strValue?.slice(0, 3) + '*'.repeat(strValue?.length - 3);
};

export const maskTestEnvValue = (value: string | number) => {
  if (testEnvironment) {
    return maskValue(value)
  } return value as string
}